import { render } from "./OrderHistoryDialog.vue?vue&type=template&id=73cf4de7&scoped=true"
import script from "./OrderHistoryDialog.vue?vue&type=script&lang=js"
export * from "./OrderHistoryDialog.vue?vue&type=script&lang=js"

import "./OrderHistoryDialog.vue?vue&type=style&index=0&id=73cf4de7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73cf4de7"]])

export default __exports__